import React, {Component} from 'react';
import {get, post,postResponse} from "../../../server/actions";
import $ from 'jquery'
import {BeatLoader} from 'react-spinners'
import '../../../assets/css/MonthPicker.min.css'
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {MONTH, URL_VERSION} from '../../../server/constants'
import {text2num} from "../../../server/word2number";
import {_addNotificationError, buildGradeName,getMonthNameByNumber, 
    gradeTextToNumber, gradeNoToText} from "../../../server/util";
let converter = require('number-to-words');
let meals = [];
let date = {};
let mealSchoolId = '';

class breakfastForm extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            show: false
        }
    }
    componentWillMount = () => {
        mealSchoolId = sessionStorage.getItem('SchoolId');
        this.getMealExcel();
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    selectDate = (e) => {
        //alert(e)
        let d = new Date(e);
        date.year = d.getFullYear();
        date.month = d.getMonth() + 1;
        //alert(JSON.stringify(date,null,2))
        this.refs.calendar.closeCalendar()
       // document.getElementById("select_all").checked=false;
		// this.props.onMealDateSelectionChange(date.year+''+(('0' +(date.month)).slice(-2)));
    }
    refreshForm=()=>{
        this.getMealExcel();
        this.refs.calendar.closeCalendar()
    }
    getMealExcel = () => {
        let mealMonths = [];
        for (let i = 0; i < 6; i++) {
            let d = new Date();
            d.setMonth(d.getMonth() + (2 - i));
            mealMonths.push("" + d.getFullYear() + (('0' + (d.getMonth())).slice(-2)))
        }       
        this.setState({show: !this.state.show}, () => {
            if (this.state.show) {
                this.setState({loading: true});                
                get('/mealsExcelSummaries/search/mealExcelList?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&itemType=Breakfast&size=10&access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                    if (data._embedded.mealsExcelSummaries.length > 0) {
                        data._embedded.mealsExcelSummaries.map((file) => {
                            let m = file.yearMonth.slice(-2);
                            let y = file.yearMonth.substring(0, 4)
                            try {
                                //  alert(file.grades)
                                let x = buildGradeName(file.grades)
                                // alert(x)
                                file.month = MONTH[m - 1] + " " + y + " , Grades: " + x;
                            }
                            catch (e) {
                                file.month = MONTH[m - 1] + " " + y + " , Grades: " + file.grades.map(grade => {
                                    return gradeTextToNumber(grade)
                                });
                            }
                            document.getElementById("file").innerHTML += '<div class="clearfix excel-file-div" style="background-color: #f5f5f5;box-shadow: 0 0 1px grey;"><a title="'+file.month+'" href="'+file.excelLink+'" class="col-md-12 col-sm-12 col-xs-12 excel-file-link-text"><i class="fa fa-file-excel-o tbl-rounded-icon bg-color-2 fa-icon"></i><label class="">' + file.month + '</label></a></div>'
                            this.setState({loading: false, show: true});
                        })
                    } else {
                        this.setState({loading: false, show: true});
                        document.getElementById("file").innerHTML = '<p>No Records Found</p>'
                    }

                }).catch(
                    (error) => {
                        this.setState({loading: false});
                        console.log('Cannot load meals', error)
                        this.setState({loading: false, show: true});
                    }
                );
            } else {
                document.getElementById("file").innerHTML = '';
            }
        });

    }
    handleSubmit(e) {
        e.preventDefault();
        let loginUser=sessionStorage.getItem('loggedUserName');
        let grades=[];
        this.props.schoolGrades.map(grade => {
            grades.push(gradeNoToText(grade));
        })
        if(document.getElementById('mealFile').value.length<=0){
            return false;
        }
        this.setState({loading: true})
        let fileInput = document.getElementById('mealFile').files[0];
        var data = new FormData();
        data.append('file', fileInput);
        let yearMonth
        if(this.props.isEdit==true){
            yearMonth=this.props.mealObject.yearMonth
        }else{
         yearMonth = "" + date.year + (('0' + (date.month)).slice(-2));
        }
        if(this.props.isEdit){ 
        data.append('mealSummaryId', this.props.mealObject.mealSummaryId);
        }
        postResponse(URL_VERSION+'/menuJson?menuType=Breakfast&mealSchoolId=' + sessionStorage.getItem("SchoolId") +'&mealSummaryId='+(this.props.mealObject.mealSummaryId||0)+ '&gradeNames=' + grades + '&yearMonth=' + yearMonth + '&loggedUser='+loginUser + '&access_token=', data).then((response) => {
            if (response.statusCode!=200) {
                throw Error(response.statusMessage);
            }
            return response;
        }).then(data => {
            console.log(data)
            meals = eval('(' + data.mealJsonData + ')');
            if (meals !== null) {
                if(this.props.isEdit){                    
                    date.year=this.props.mealObject.yearMonth.substring(0,4);
                    date.month=this.props.mealObject.yearMonth.slice(-2);
                }
                this.props.loadBreakfast(meals, grades, date);
            }
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message, this)
                console.log('Cannot load meals', error)
            }
        );
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    render(){
        return(
        <section className="mainContent full-width clearfix">
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                <BeatLoader size={20} color={'#ea7066'} loading={this.state.loading} />
            </div>
            <div className="row">
                <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="col-md-8 col-sm-12 col-xs-12 text-center createmenu-panel">
                        <div className="panel panel-primary">
                            <div className="panel-heading text-center">
                                <h3 className="panel-title"> {this.props.isEdit ? 'Edit Breakfast Menu' : 'Create Breakfast Menu'}</h3>
                            </div>
                            <div className="panel-body">
                            {this.props.isEdit?
                                (<div className="uploadFileInfo col-md-12 createmenu-month-group">
                                <label className="custom-label col-md-3 text-left">Selected Month</label>
                                <div className="input-group col-md-7 col-sm-12 col-xs-12" style={{backgroundColor: '#f5f5f5', boxShadow: '0 0 1px grey'}} >

                                   <label>{getMonthNameByNumber((this.props.mealObject.yearMonth||'').slice(-2))+' '+(this.props.mealObject.yearMonth||'').substring(0,4)}</label>
                                </div>
                            </div>):
                                    (<div className="uploadFileInfo col-md-12 createmenu-month-group">
                                        <label className="custom-label col-md-3 text-left" style={{margin: '10px 0px'}}>Select Month</label>
                                        <div className="input-group col-md-7 col-sm-12 col-xs-12">
                                            <Datetime ref='calendar' dateFormat="MMMM YYYY" timeFormat={false}
                                                      closeOnSelect={true}
                                                      onChange={this.selectDate.bind(this)} renderInput={this.renderInput}/>
                                        </div>
                                    </div>)
                                }
                                <div className="clearfix"></div>
                                <div className="col-md-12 col-sm-12 col-xs-12 createmenu-link-group">
                                    <p className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-left">Upload breakfast data to create breakfast menu. Download &nbsp;<a
                                            href="https://s3.amazonaws.com/mealmanage-prod/SampleFiles/BreakfastMenu.xlsx"
                                            download>Sample
                                            file</a>
                                    </p>
                                </div>
                                <div className="col-md-7 col-md-offset-3 col-sm-12 col-xs-12 text-center">
                                    <label className="control-label"> Import Breakfast Data </label>
                                </div>
                                <div className="uploadFileInfo col-md-12 col-sm-12 col-xs-12 createmenu-file-group">
                                    <div className="input-group col-md-7 col-md-offset-3 col-sm-12 col-xs-12">                                                
                                        <input type="file" className="form-control" style={{opacity: '1', zIndex: '0'}}
                                                id="mealFile" aria-describedby="basic-addon21" 
                                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                onChange={(e)=>{
                                                        let validExts = new Array(".xlsx", ".xls");
                                                        let fileExt = e.target.files[0].name.split('.').pop();
                                                        const fileSize = e.target.files[0].size;
                                                        const fileMb = fileSize / 1024 ** 2;
                                                        if (validExts.indexOf('.'+fileExt) < 0) {
                                                            _addNotificationError("Invalid file format. Please select valid file format (" +
                                                                validExts.toString() + ")",this);
                                                            e.target.value='';
                                                        return false;
                                                        }else if(fileMb >= 2){
                                                            _addNotificationError("Please select a file less than 2MB.",this);
                                                            e.target.value='';
                                                            return false;
                                                        }
                                                        else return true;
                                                   }}
                                                />
                                        <button id="OpenUpload" className="input-group-addon" onClick={() => {
                                                    $('#mealFile').click()
                                            }}><i className="fa fa-upload" aria-hidden="true" />
                                        </button>
                                    </div>                                        
                                </div>
                                <div className="col-md-7 col-md-offset-3 text-center">
                                        <button type="submit" id="submit" className="btn btn-sm btn-primary"><i
                                            className="fa fa-arrow-circle-right"></i><span>Proceed</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-xs-12 createmenu-panel">
                            <div className="panel panel-primary">
                                <div className="panel-heading text-center"><h3 className="panel-title">Breakfast Excel File
                                    Records</h3></div>
                                <div className="panel-body">
                                    <div id="file"></div>
                                </div>
                            </div>
                        </div>
                </form>

            </div>
        </section>
        )
    }
}
export default breakfastForm


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/breakfastForm.jsx